// Judgeme Close Modal

document.addEventListener("DOMContentLoaded", function() {

  let outsideClickHandler = null;

  /* === Enable outside-click close === */
  function enableOutsideClickClose(modalWrapper, modalContainer) {
    if (outsideClickHandler) return;

    outsideClickHandler = function(event) {
      const clickedOutside = !modalContainer.contains(event.target);

      if (clickedOutside) {
        modalWrapper.style.display = "none";
        disableOutsideClickClose();
      }
    };

    document.addEventListener("mousedown", outsideClickHandler);
  }

  /* === Disable outside-click close === */
  function disableOutsideClickClose() {
    if (outsideClickHandler) {
      document.removeEventListener("mousedown", outsideClickHandler);
      outsideClickHandler = null;
    }
  }

  /* === MutationObserver to detect modal open/close === */
  const observer = new MutationObserver(() => {
    const modalWrapper = document.querySelector(".jdgm-review-widget-modal");
    const modalContainer = document.querySelector(".jdgm-write-review-modal__container");

    if (!modalWrapper || !modalContainer) {
      disableOutsideClickClose();
      return;
    }

    const isOpen =
      modalWrapper.style.display === "block" ||
      modalWrapper.classList.contains("jdgm-modal-open");

    if (isOpen) {
      enableOutsideClickClose(modalWrapper, modalContainer);
    } else {
      disableOutsideClickClose();
    }
  });

  /* === Observe body for Judge.me dynamic changes === */
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class"]
  });

});